import { register } from "async-ops";
import { callMvcApi  } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS';


export const service = async (data) => {
  const options: object = {
    url:  '/Api/Utility/DeleteNotification/',
    method: "POST",
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  }
  const response = await callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_NOTIFICATIONS, service, mock);
